import * as types from '../types'

const initialState = {
    productId: null,
    productType: null // 'course', 'bundle', or 'digital_product'
}

const enrollmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_ENROLLMENT_PRODUCT:
            return {
                ...state,
                productId: action.payload.productId,
                productType: action.payload.productType
            }
        
        case types.CLEAR_ENROLLMENT_PRODUCT:
            return {
                ...state,
                productId: null,
                productType: null
            }
        
        default:
            return state
    }
}

export default enrollmentReducer
